exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-status_save-now_1Blzi {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"save-now": "save-status_save-now_1Blzi",
	"saveNow": "save-status_save-now_1Blzi"
};